import React from 'react';

const chipStyle = (color, bg, border) => ({
    display: 'inline-flex', alignItems: 'center', fontSize: 11, fontWeight: 600, lineHeight: 1,
    borderRadius: 6, padding: '3px 7px', color, backgroundColor: bg, border: `1px solid ${border}`, whiteSpace: 'nowrap',
});

/**
 * What the image picker shows about an AWS image besides its name: the
 * architecture, the Marketplace software fee or missing subscription, a free
 * trial, and when it was built. `software` is the catalog's pricing entry for
 * the image's product code, or null for images without one.
 */
export default function AwsImageChips({ image, software }) {
    if (!image) return null;
    return (
        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
            {image.arch && <span style={chipStyle('#475569', '#eef2f7', '#e2e8f0')}>{image.arch}</span>}
            {software && (software.subscribed === false
                ? <span style={chipStyle('#b91c1c', '#fef2f2', '#fecaca')} title="This account has no active Marketplace subscription for the product this image is built from">Marketplace subscription required</span>
                : software.flatRate != null
                    ? <span style={chipStyle('#92400e', '#fffbeb', '#fcd34d')} title={`Marketplace software fee${software.productName ? ` for ${software.productName}` : ''}, charged per instance hour on top of the instance price`}>software ${software.flatRate.toFixed(2)}/hr</span>
                    : software.minRate != null
                        ? <span style={chipStyle('#92400e', '#fffbeb', '#fcd34d')} title="Marketplace software fee varies by instance type">software from ${software.minRate.toFixed(2)}/hr</span>
                        : <span style={chipStyle('#92400e', '#fffbeb', '#fcd34d')} title="This image carries a Marketplace product code; the fee could not be read with this credential">software fee applies</span>)}
            {software && software.freeTrial && software.freeTrial.days && (
                <span style={chipStyle('#065f46', '#ecfdf5', '#a7f3d0')} title="Free trial granted by the Marketplace agreement (one instance per type)">{software.freeTrial.days}-day free trial</span>
            )}
            {image.createdAt && (
                <span style={{ fontSize: 12, color: '#64748b', whiteSpace: 'nowrap' }}>built {String(image.createdAt).slice(0, 10)}</span>
            )}
        </span>
    );
}
